<template>
    <u-file-input-filled-rounded v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-file-input-filled-rounded>
</template>

<script>
import UFileInputFilledRounded from "@/components/publish/styles/forms/u-file-input-filled-rounded.vue";

export default {
    props: {},
    components: {
        UFileInputFilledRounded,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
